import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useGiftStatuses from '../../../hooks/useGiftStatuses';
import { setMeetingSlots, setTimezone } from '../../../store/giftFlow/giftFlow.actions';

enum ChiliPiperAction {
  close = 'close',
  timeslotSelected = 'timeslot-selected',
  bookingConfirmed = 'booking-confirmed',
}

interface IChiliPiperMessageEvent {
  data: {
    action: ChiliPiperAction;
    args?: TimelotSelectedArgs | BookingConfirmedArgs;
  };
}

interface TimelotSelectedArgs {
  time: string;
  timezone: string;
  duration: number;
}

interface BookingConfirmedArgs {
  assigneeId: string;
  actionType: string;
  slot: {
    start: number;
    end: number;
  };
  eventId: string;
}

const useChiliPiperCalendar = (): void => {
  const dispatch = useDispatch();
  const { goPreviousStep, goNextStep } = useGiftStatuses();

  useEffect(() => {
    const captureEvent = (event: IChiliPiperMessageEvent) => {
      const { data } = event;

      switch (data.action) {
        case ChiliPiperAction.close:
          goPreviousStep();
          break;
        case ChiliPiperAction.timeslotSelected: {
          const args = data.args as TimelotSelectedArgs;
          dispatch(setTimezone(args.timezone));
          break;
        }
        case ChiliPiperAction.bookingConfirmed: {
          const args = data.args as BookingConfirmedArgs;

          const startAt = new Date(args.slot.start).toISOString();
          const endAt = new Date(args.slot.end).toISOString();

          dispatch(setMeetingSlots([{ startAt, endAt }]));

          goNextStep();
          break;
        }
        default:
          break;
      }
    };

    window.addEventListener('message', captureEvent, false);

    return () => {
      window.removeEventListener('message', captureEvent);
    };
  }, [dispatch, goNextStep, goPreviousStep]);
};

export default useChiliPiperCalendar;
